import React, { useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Table, Row, Form } from 'reactstrap';
import { useQueryClient } from 'react-query';
import { confirmAlert } from 'react-confirm-alert';
import { IoIosAdd } from 'react-icons/io';
import { HiPencil } from 'react-icons/hi';
import { MdDelete } from 'react-icons/md';
import moment from 'moment';
import $ from 'jquery';
import Tooltip from '@mui/material/Tooltip';

import Sidebar from '../Sidebar.js';
import ButtonComponent from 'components/Buttons';
import './style.scss';
import ModalComponent from 'components/Modal/index.js';
import Loading from 'components/Loading';
import {
  HTTP_UNPROCESSABLE_ENTITY,
  HTTP_OK,
  HTTP_NOT_ACCESS,
  HTTP_INTERNAL_SERVER_ERROR,
  HTTP_EXPECTATION_FAILED,
  HTTP_CREATED,
  FAILURE,
  PERFORMANCE_REVIEW_CYCLE_HAS_BEEN_USED
} from 'constants/StatusCode.js';
import AlertComponent from 'components/Alert/index.js';
import { apiCreatePerformanceReview, apiUpdatePerformanceReview, apiDeletePerformanceReview } from 'api/masterData';
import { USE_LIST_PERFORMANCE_REVIEW, USE_LIST_USED_PERFORMANCE_REVIEW } from 'constants/MasterData';
import { useGetPerformanceReview, useGetUsedPerformanceReview } from 'hook/useMasterData.js';
import { MAX_LENGTH_20 } from 'constants/ProfileEmployee.js';
import { isNotNullObject } from 'helpers/index';
import InputField from 'components/Input/InputField.js';
import { ThemContext } from 'layouts/Admin';
import { ROLE_VIEW, DISABLE_ROLE } from 'constants/index.js';
import { DISABLE_BUTTON_ROLE } from "constants/index.js";
import { PER_PAGE } from "constants/MasterData.js";

const DEFAULT_FORM_DATA = {
  id: 0,
  name: '',
  start_date: null,
  end_date: null,
  error_name: '',
};

const DEFAULT_FORM_DATA_ERROR = {
  error_name: '',
  error_start: '',
  error_end: '',
};

const PerformanceReview = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isShowModal, setShowModal] = useState(false);
  const [stateButton, setStateButton] = useState(false);
  const dataInforUser = useContext(ThemContext);
  const filter = {
    page: 1,
    per_page: PER_PAGE,
  };
  const { data: uListPerformanceReview, isLoading: isLoadingListPerformanceReview } = useGetPerformanceReview(filter);
  const { data: listUsedPerformanceReview } = useGetUsedPerformanceReview();
  const usedIds = listUsedPerformanceReview?.data?.performance_review_cycle_ids || [];
  const scrollBottom = useRef(null)
  const [formAdd, setFormAdd] = useState(DEFAULT_FORM_DATA);

  const [isShowAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [textModal, setTextModal] = useState({
    title: t('masterData.performanceReview.morePerformanceReview'),
    btn_submit: t('common.add'),
  });

  const openAddPerformanceReview = () => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setShowModal(true);
    setFormAdd({
      ...formAdd,
      ...DEFAULT_FORM_DATA,
    });
    setTextModal({
      title: t('masterData.performanceReview.morePerformanceReview'),
      btn_submit: t('common.add'),
    });
  };

  function openEditPerformanceReview(performanceReview) {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    setShowModal(true);
    setTextModal({
      title: t('masterData.performanceReview.updatingPerformanceReview'),
      btn_submit: t('common.update'),
    });
    setFormAdd({
      ...formAdd,
      id: performanceReview.id,
      name: performanceReview.name,
      start_date: performanceReview.start_date ? moment(performanceReview.start_date, 'YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
      end_date: performanceReview.end_date ? moment(performanceReview.end_date, 'YYYY-MM-DD') : moment(new Date()).add(2, 'month').format('YYYY-MM-DD'),
      ...DEFAULT_FORM_DATA_ERROR,
    });
  }

  const handleInput = (e) => {
    setFormAdd({ ...formAdd, [e.target.name]: e.target.value, error_name: '' });
  };

  const alertConfirm = (id) => {
    if (dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW) {
      return;
    }
    confirmAlert({
      title: t('infoEmployee.youWantToDelete'),
      buttons: [
        {
          label: t('infoEmployee.cancel'),
          className: 'btn-alert-cancel',
        },
        {
          label: t('infoEmployee.ok'),
          className: 'btn-alert-ok',
          onClick: async () => {
            const response = await apiDeletePerformanceReview(id);
            if (response?.status === HTTP_NOT_ACCESS) {
              setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
              setShowAlert(true);
            }
            if (response?.status === HTTP_OK) {
              setMessage(response.data.message);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_LIST_PERFORMANCE_REVIEW);
              queryClient.invalidateQueries(USE_LIST_USED_PERFORMANCE_REVIEW);
            }

            if (
              response?.status === HTTP_INTERNAL_SERVER_ERROR ||
              response?.status === HTTP_EXPECTATION_FAILED
            ) {
              setMessage(response?.data?.message);
              setShowAlert(true);
              queryClient.invalidateQueries(USE_LIST_PERFORMANCE_REVIEW);
              queryClient.invalidateQueries(USE_LIST_USED_PERFORMANCE_REVIEW);
            }

            if (response?.data?.code === FAILURE || response?.data?.code === PERFORMANCE_REVIEW_CYCLE_HAS_BEEN_USED) {
              setMessage(t('masterData.performanceReview.cannotDeletePerformanceReview'));
              setShowAlert(true);
              queryClient.invalidateQueries(USE_LIST_PERFORMANCE_REVIEW);
              queryClient.invalidateQueries(USE_LIST_USED_PERFORMANCE_REVIEW);
            }
          },
        },
      ],
    });
  };

  function validate() {
    var messages = {};
    var focus = true;
    if (!formAdd.name.trim()) {
      messages.error_name = t('common.pleaseFillOutThisField');
      if (focus) {
        $('input[name=name]').focus();
        focus = false;
      }
    }
    if (isNotNullObject(messages)) {
      setFormAdd({
        ...formAdd,
        ...messages,
        name: formAdd.name.trim(),
      });
      return false;
    }
    return true;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormAdd({ ...formAdd, ...DEFAULT_FORM_DATA_ERROR });
    setStateButton(true);

    if (!validate()) {
      setStateButton(false);
      return;
    }

    setFormAdd({ ...formAdd, ...DEFAULT_FORM_DATA_ERROR });

    const data = {
      name: formAdd.name.trim(),
      start_date: formAdd.start_date ? moment(formAdd.start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
      end_date: formAdd.end_date ? moment(formAdd.end_date, 'YYYY-MM-DD').format('YYYY-MM-DD') : moment(new Date()).add(2, 'month').format('YYYY-MM-DD'),
    };

    let response = {};
    if (!formAdd.id) {
      response = await apiCreatePerformanceReview(data);
    } else {
      response = await apiUpdatePerformanceReview(formAdd.id, data);
    }
    if (response?.status === HTTP_UNPROCESSABLE_ENTITY && response?.data?.message) {
      const msg = response.data.message;
      var focus = true;
      if (msg?.name) {
        if (focus) {
          $('input[name=name]').focus();
          focus = false;
        }
      }
      setFormAdd({
        ...formAdd,
        error_name: msg?.name
          ?.map((item) => {
            return item;
          })
          .join('\n')
      });
      setStateButton(false);
      return;
    }
    
    if (response?.status === HTTP_NOT_ACCESS && response?.data?.is_edit) {
      setMessage(t('common.pleaseCheckAgainYouAreNotAuthorizedToUseThisFeature'));
      setShowAlert(true);
      setStateButton(false);
      return;
    }
    if (response?.status === HTTP_OK || response?.status === HTTP_CREATED) {
      setShowModal(false);
      setStateButton(false);
      setFormAdd({
        ...formAdd,
        ...DEFAULT_FORM_DATA,
      });
      setMessage(response.data.message);
      setShowAlert(true);
      queryClient.invalidateQueries(USE_LIST_PERFORMANCE_REVIEW);
    }
    setTextModal({
      ...textModal,
      title: t('masterData.moreData'),
      btn_submit: t('common.add'),
    });
    setStateButton(false);
  };

  return (
    <div className="performance-review-master-data">
      <Row>
        <Col lg={3} xl={2}>
          <Sidebar />
        </Col>
        <Col lg={9} xl={10}>
        <Row>
            <Col className="md-12">
              <div className="box-group d-flex float-right">
                <ButtonComponent
                  text={t('common.add')}
                  icon={<IoIosAdd />}
                  className="button-add"
                  addClass={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_BUTTON_ROLE
                    } ml-3`}
                  handleClick={openAddPerformanceReview}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className="md-12">
              <div className="table-list">
                <Table className="align-items-center table-hover" responsive>
                  <thead>
                    <tr>
                      <th scope="col">{t('masterData.STT')}</th>
                      <th scope="col">{t('masterData.performanceReview.namePerformanceReview')}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {uListPerformanceReview?.data?.items?.length === 0 ? (
                      <tr>
                        <td colSpan={4}>
                          <div className="error-no-data">{t('common.notData')}</div>
                        </td>
                      </tr>
                    ) : (
                      uListPerformanceReview?.data?.items?.map((performanceReview, index) => {
                        const isUsed = usedIds.includes(performanceReview.id);
                        return (
                          <tr key={index}>
                            <td>{index + 1 > 9 ? index + 1 : <>0{index + 1}</>}</td>
                            <td className="text-bold">{performanceReview.name}</td>
                            <td>
                              <div className={`col-action d-flex float-right`}>
                                <div
                                  className={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                    } edit mr-2`}
                                  onClick={() => openEditPerformanceReview(performanceReview)}
                                >
                                  <HiPencil />
                                </div>
                                <Tooltip title={isUsed ? "Đang được sử dụng" : ""} arrow disableHoverListener={!isUsed}>
                                  <div
                                    className={`${dataInforUser?.hr_permission?.master_data_permission === ROLE_VIEW && DISABLE_ROLE
                                      } remove mr-3`}
                                    onClick={() => !isUsed && alertConfirm(performanceReview.id)}
                                    style={{ cursor: isUsed ? 'not-allowed' : 'pointer', opacity: isUsed ? 0.5 : 1 }}
                                  >
                                    <MdDelete />
                                  </div>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                    {isLoadingListPerformanceReview && (
                      <tr>
                        <td colSpan={4}>
                          <Loading addClass="mt-2" />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <ModalComponent
        classNameCustom={'modal-custom-performance-review'}
        toggle={() => setShowModal(!isShowModal)}
        isShowModal={isShowModal}
        title={textModal.title}
      >
        <Form className="mt-3" onSubmit={handleSubmit}>
          <div className="fieldset-group mt-4 mb-4">
            <InputField
              label={t('masterData.performanceReview.namePerformanceReview')}
              isRequired={true}
              variant="outlined"
              name="name"
              defaultValue={formAdd.name}
              maxLength={MAX_LENGTH_20}
              onHandleInput={handleInput}
              error={formAdd.error_name}
            />
          </div>

          <Row className="mt-5">
            <Col className="md-6">
              <ButtonComponent
                text={t('common.cancel')}
                addClass="w-100 btn-bg-yellow2"
                handleClick={() => setShowModal(false)}
              />
            </Col>
            <Col className="md-6">
              <ButtonComponent
                text={textModal.btn_submit}
                addClass="w-100"
                handleClick={() => setShowModal(true)}
                type="submit"
                hasDisabled={stateButton}
                isLoading={stateButton}
              />
            </Col>
          </Row>
          <div ref={scrollBottom}></div>
        </Form>
      </ModalComponent>
      <AlertComponent toggle={() => setShowAlert(!isShowAlert)} isShowAlert={isShowAlert}>
        {message}
      </AlertComponent>
    </div>
  );
};

export default PerformanceReview;
